import { useState } from 'react';
import styled from 'styled-components';
import Header from './Header';
import Sidebar from './Sidebar';

const DashboardLayout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <>
            <Header />
            <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />
            <Main $marginLeft={collapsed ? 60 : 200}>{children}</Main>
        </>
    );
};

const Main = styled.div`
    margin-left: ${({ $marginLeft }) => $marginLeft}px;
    transition: margin-left 0.2s ease;
`;

export default DashboardLayout;
